import React from 'react';

import { PointsText } from 'components/points-text';
import { ResponsiveCarousel } from 'components/responsive-carousel';

import { styles } from './constants';
import {
  CarouselItem,
  Image,
  ItemName,
  Title,
  WidgetDescription,
  WidgetTitle,
  Wrapper,
} from './styled';
import { IRewardsCarouselProps, RewardCarouselCategory } from './types';

export const RewardsCarouselWidget: React.FC<IRewardsCarouselProps> = ({
  rewardsCarouselTitle,
  rewardsCarouselDescription,
  rewardCarouselCategories,
}) => {
  const RewardsCategories = ({
    rewardCategory,
    categoryIndex,
  }: {
    rewardCategory: RewardCarouselCategory;
    categoryIndex: number;
  }) => (
    <>
      <Title>
        {rewardCategory.label.locale} <PointsText />
      </Title>
      <ResponsiveCarousel>
        {rewardCategory.rewards.map((reward, i) => {
          const styleIndex = categoryIndex > 5 ? 0 : categoryIndex;
          const itemNameColor = styles[styleIndex]?.color ?? 'black';
          const carouselBackgroundColor = styles[styleIndex]?.background ?? 'transparent';

          return (
            <CarouselItem key={i} backgroundColor={carouselBackgroundColor}>
              <Image objectFitContain alt={reward.name.locale ?? ''} image={reward.image.locale} />
              <ItemName color={itemNameColor}>{reward.name.locale}</ItemName>
            </CarouselItem>
          );
        })}
      </ResponsiveCarousel>
    </>
  );

  return (
    <Wrapper>
      <WidgetTitle>{rewardsCarouselTitle?.locale ?? ''}</WidgetTitle>
      <WidgetDescription>{rewardsCarouselDescription?.locale ?? ''}</WidgetDescription>
      {rewardCarouselCategories.map((rewardCategory, i) => (
        <RewardsCategories key={i} categoryIndex={i} rewardCategory={rewardCategory} />
      ))}
    </Wrapper>
  );
};
